//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'BlogArticle',
    async asyncData({ $axios, error, params, i18n, redirect, localePath }) {
        if (i18n.locale === 'en') {
            return redirect(localePath('/'));
        }

        let model = {};

        await $axios
            .$get(`/article/by-slug/${params.article}`)
            .then((res) => {
                if (res.success === 1) {
                    model = res.data;
                }
            })
            .catch((err) => {
                return error({ statusCode: err.response?.status, message: err.response?.statusText });
            });

        if (!model) {
            return error({ statusCode: 404, message: i18n.t('errors.page_not_found') });
        }

        return {
            model,
        };
    },
    head() {
        const meta = [
            {
                hid: 'title',
                name: 'title',
                content: this.model.og_title,
            },
            {
                hid: 'og-title',
                property: 'og:title',
                content: this.model.og_title,
            },
            {
                hid: 'description',
                name: 'description',
                content: this.model.og_description,
            },
            {
                hid: 'og-description',
                property: 'og:description',
                content: this.model.og_description,
            },
            {
                property: 'article:published_time',
                content: this.$dayjs(this.model.created_at * 1000).format('YYYY-MM-DD'),
            },
            {
                name: 'publish-date',
                content: this.$dayjs(this.model.created_at * 1000).format('YYYY-MM-DD'),
            },
        ];

        const ogImage = this.model.og_image_cropped || this.model.cover_image;

        if (ogImage) {
            meta.push({
                hid: 'og-image',
                property: 'og:image',
                content: ogImage,
            });
            meta.push({
                hid: 'og-image-url',
                property: 'og:image:url',
                content: ogImage,
            });
        }

        return {
            title: this.model.title,
            meta,
        };
    },
};
